import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import SplitText from "../../helpers/Split3.min.js";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "./hero.scss";

gsap.registerPlugin(ScrollTrigger);

export const Hero = () => {
  const triggerRef = useRef(null);
  const textRef = useRef(null);
  const h3Ref = useRef(null);
  const h2Ref = useRef(null);
  const h1Ref = useRef(null);

  useEffect(() => {
    const split = new SplitText(textRef.current, {
      type: "lines",
      linesClass: "lineChildren",
    });
    // console.log(triggerRef.current)

    const splitParent = new SplitText(textRef.current, {
      type: "lines",
      linesClass: "lineParent",
    });

    const tl = gsap.timeline();
    tl.to(textRef.current, {
      y: 0,
      opacity: 1,
    }).to(split.lines, {
      duration: 1,
      y: 0,
      stagger: 0.1,
      ease: "power4.out",
    });
  }, []);

  return (
    <section
      className="hero section"
      id="hero"
      data-scroll-section
      ref={triggerRef}
    >
      <div className="hero-wrapper">
        <div className="hero-content" ref={textRef}>
          <h3 ref={h3Ref}>hello, i'm</h3>
          <h1 ref={h1Ref}>murad muqbel.</h1>
          <h2 ref={h2Ref}>
            This portfolio was made to showcase some of my individual and team
            projects during my journey at <span>DCI</span>.
          </h2>
        </div>
      </div>
    </section>
  );
};
